// on product-option-size__text click, fade in the #popup
// $(document).on('click', '.product-option-size__text', function() {
//     $('#popup').fadeIn();
//     }
// );

// $(document).on('click', '.close', function() {
//     $('#popup').fadeOut();
//     }
// );

// on document load
$(document).ready(function() {
  // if the user has scrolled down the page past the #product-main, add the 'super-active' class
  // to the product-sticky-bar

  // on scroll event 
  // if the user has scrolled down the page past the #product-main, add the 'super-active' class
  // to the product-sticky-bar
  $(document).on('scroll', function() {
      const scrollPosition = window.scrollY;
      const productMainOffset = document.querySelector('.product-add-to-cart').offsetTop;
      const productStickyBar = document.querySelector('.product-sticky-bar');
      const productStickyBarHeight = productStickyBar.offsetHeight;
      console.log('scroll position',scrollPosition);
      console.log('main offset',productMainOffset);
      if (scrollPosition > 1000) {
          productStickyBar.classList.add('super-active');
          // console.log('is super active');
      } else {
          productStickyBar.classList.remove('super-active');
          // console.log('not super active');
      }
  });

  // Check if a session variable 'firstVisit' is set
   if (!sessionStorage.getItem('firstVisit')) {
      // If 'firstVisit' is not set, show the hero banner
      // if .hero-banner exists, then show it
      if (document.querySelector('.hero-banner')) {
          document.querySelector('.hero-banner').style.display = 'flex';
      }

      // Set the session variable to indicate that this is their first visit
      sessionStorage.setItem('firstVisit', 'true');
  }

  // if the url contains the string 'hero', show the .hero-banner
  if (window.location.href.indexOf('hero') !== -1) {
      document.querySelector('.hero-banner').style.display = 'flex';
  }

  console.log('firstVisit:', sessionStorage.getItem('firstVisit'));
  console.log('harc-custom.js loaded');
  console.log('where is first visit');
});




$(document).ready(function() {


  // Destroy any existing slider
  // $('.product-slider_thumb').slick('unslick'); 
  
  // Reinitialize the slider with custom options
  // $('.product-slider_thumb').slick({
  //   infinite: true,
  //   slidesToShow: 4, // Adjust the number of thumbnails shown
  //   slidesToScroll: 1,
  //   // autoplay: true,
  //   // autoplaySpeed: 2000,
  //   arrows: true,
  //   dots: false
  // });




  $('.popup-add').click(function(event) {
    $this = $(this);  
    productColor = $(this).data('product-color');
    productSize = $(this).data('product-size');
    // productSide = $(this).data('product-side');
    productHandle = $(this).data('product-handle');
    single_id = $(this).data('single-product-id');
    // console.log('productColor:', productColor);
    console.log('productHandle:', productHandle);
    $.ajax({
      url: '/products/' + productHandle + '.js',
      type: 'GET',
      dataType: 'json',
      success: function(product) {
        
        // console.log('success');
        var pair_id = findVariantId(product, productColor, productSize, 'Pair');
        // console.log('pair_id:', pair_id);
        // Add pair to cart
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          data: {
            quantity: 1,
            id: pair_id
          },
          success: function(response) {


            $.ajax({
              url: '/cart/change.js',
              type: 'POST',
              data: {
                quantity: 0,
                id: single_id
              },
              beforeSend: function() {
                $this.html('Adjusting Cart...');
                $('img.image-1').css('opacity', '0.5');
              },
              success: function(response) {
                $('.single-sleeve-popup__close').addClass('refresh');
                $('.back-in-stock-popup .close').addClass('refresh');
                
                $('img.image-1').css('opacity', '1');
                // console.log('response:', response);
                $this.html('It\'s now a pair!').addClass('added');

                // if all .popup-add buttons have the class 'added', then hide the popup
                
                setTimeout(function() {
                  if ($('.popup-add').length === $('.popup-add.added').length) {
                    $('.single-sleeve-popup').hide();
                    $('.single-sleeve-overlay').hide();
                    // refresh the page
                    location.reload();
                  }
                  $('.recommended-pairs').slick('next');
                }
                , 1000);
              },
              error: function(error) {
                console.log('Error:', error);
              }
            });
          },
          error: function(error) {
            console.log('Error:', error.responseText.description);
            if (error.status === 422) {
              $this.html('Sorry, Not Available!');

              // add the pair_id to session storage to use later
              sessionStorage.setItem('pair_id', pair_id);
              console.log('pair_id:', sessionStorage.getItem('pair_id'));
              
              


              $('.back-in-stock-trigger').show();

  
              // set session storage to hide the popup

            }
          }
        });
      },
      error: function(error) {
        console.log('Error:', error);
        // if error stats that the variant is not available, then adjust button text

      }
    });
    
  });
});



function findVariantId(product, color, size, side) {
  // Assuming 'product' is an object with a 'variants' array
  for (const variant of product.variants) {
    if (variant.option1 === color &&
      variant.option2 === size &&
      variant.option3 === side) {
        return variant.id;

          }
  }
  return null; // Variant not found
}


$('.single-sleeve-popup__close, .single-sleeve-overlay, .no-thanks').click(function() {
  // if has class refresh, then refresh the page
  $('.single-sleeve-popup').hide();
  $('.single-sleeve-overlay').hide();
  if ($(this).hasClass('refresh')) {
    location.reload();
  }
});

$('.back-in-stock-popup .close').click(function() {
  $('.single-sleeve-popup').hide();
  $('.single-sleeve-overlay').hide();
  if ($(this).hasClass('refresh')) {
    location.reload();
  }
});



$(document).ready(function () {
  // Check if the Slick Slider is initialized
  if ($('.product-slider').hasClass('slick-initialized')) {
    // Reinitialize or update the slider with arrows
    $('.product-slider').slick('slickSetOption', {
      arrows: true, // Enable arrows
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>'
    }, true); // `true` reinitializes the slider
  } else {
    // Initialize the slider if not already initialized
    $('.product-slider').slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>'
    });
  }
});

  // Listen for slide changes
  $('.product-slider').on('afterChange', function (event, slick, currentSlide) {
    // Pause all videos first
    $('.product-slider video').each(function () {
      this.pause();
      this.currentTime = 0; // Optional: Reset to the beginning
    });

    // Find the active slide
    var activeSlide = $(slick.$slides[currentSlide]);

    // Check if it contains a video and play it
    var video = activeSlide.find('video')[0];
    if (video) {
      video.play();
    }
  });

/**
 * Auto-selects the White color variant on load, except on the calf sleeve page.
 * Adds guards so we don't trigger theme change handlers before the DOM is ready.
 */
function autoSelectWhiteColorVariantExceptCalfSleeve() {
  // 1) Skip on the excluded product page
  if (document.querySelector('.product-page--kinesiology-compression-calf-sleeve')) return;

  // 2) Utility: wait for required elements up to a timeout
  function waitFor(selectors, timeout = 5000, interval = 100) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const timer = setInterval(() => {
        const allPresent = selectors.every(sel => document.querySelector(sel));
        if (allPresent) {
          clearInterval(timer);
          resolve();
        } else if (Date.now() - start > timeout) {
          clearInterval(timer);
          reject(new Error('Timed out waiting for: ' + selectors.join(', ')));
        }
      }, interval);
    });
  }

  // 3) Main runner
  const run = async () => {
    try {
      // Wait for the option label and any common price container the theme might use
      await waitFor([
        'label[for="option-Color-White"]',
        // one of these usually exists on Shopify/Headless themes – harmless if extra
        '.product__price, .price, [data-product-price], [data-price], #ProductPrice'
      ]);

      const label = document.querySelector('label[for="option-Color-White"]');
      if (!label) {
        console.warn('White color variant label not found.');
        return;
      }

      // Click once; do NOT manually set checked or dispatch 'change'
      // (double-firing can race with theme code and cause null .style errors)
      requestAnimationFrame(() => {
        label.click();
      });
    } catch (e) {
      // Not critical—just skip quietly
      // console.info(e.message);
    }
  };

  // Run when ready; cover cached and fresh loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
}

// Invoke
autoSelectWhiteColorVariantExceptCalfSleeve();